/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/volume_off_medium'
export default icon
